import { render } from "./auth-header.vue?vue&type=template&id=0ba2a49e&lang=html"
import script from "./auth-header.vue?vue&type=script&lang=js"
export * from "./auth-header.vue?vue&type=script&lang=js"

import "./auth-header.vue?vue&type=style&index=0&id=0ba2a49e&lang=scss"

import exportComponent from "/builds/unistroy/frontend.vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__